<template>
  <div>
    <v-progress-circular
      v-if="status == 'starting'"
      :title="status"
      indeterminate
      color="black"
      size="20"
      width="1"
      class="ml-3"
    />
    <span v-else-if="['running', 'available'].includes(status)" class="size-status" style="color: green">
      <v-icon small color="green" class="icon-status pb-1">mdi-lightbulb-on</v-icon>
      Ligado
    </span>
    <span v-else-if="status == 'stopped'" class="size-status" style="color: #e91e63">
      <v-icon small color="#e91e63" class="icon-status pb-1">mdi-lightbulb-off</v-icon>
      Desligado
    </span>
    <span v-else class="size-status" style="color: gray">
      {{ treatedStatus }}
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      status: {
        type: String,
        required: true
      }
    },
    computed: {
      treatedStatus() {
        return this.status.charAt(0).toUpperCase() + this.status.slice(1).toLowerCase();
      }
    }
  };
</script>

<style>
  .size-status {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }
  .size-status .v-icon {
    font-size: 0.9rem !important;
  }
  .icon-status {
    margin-right: 1.7px !important;
  }
</style>
